var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('section',[_c('h3',[_vm._v("待办事项")])]),_c('section',[_c('h3',[_vm._v("常用功能入口")])]),_c('section',[_c('h3',[_vm._v("今日数据概览")])])])
}]

export { render, staticRenderFns }